module.exports = __webpack_public_path__ + "img/ARQ.5c1da36f.jpg";